<template>
  <div class="relative min-h-screen overflow-x-hidden">
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <BottomTabBar v-if="showBottomTabs" />
  </div>
</template>

<script>
import { computed } from "vue";
import { useRoute } from "vue-router";
import BottomTabBar from "@/components/BottomTabBar.vue";

export default {
  components: {
    BottomTabBar,
  },
  setup() {
    const route = useRoute();

    const showBottomTabs = computed(() => {
      return route.path === "/home" || route.path === "/deliver";
    });

    return { showBottomTabs };
  },
};
</script>

<style>
/* Page Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Loading spinner animation */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 0.8s linear infinite;
}

/* Slide animations */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes scaleIn {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.animate-slide-in {
  animation: slideIn 0.3s ease;
}

.animate-scale-in {
  animation: scaleIn 0.4s ease;
}
</style>
